export default "__VITE_ASSET__qfmciB2XnzuHnI0uF$ejHQ__";